// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"FilterBar_filterContainer__1-0Iq","placeholderShimmer":"FilterBar_placeholderShimmer__2_aFN"};